
if (typeof String.isEmpty === "undefined") {
	String.isEmpty = function(str) {
		return str === undefined || str === null || str.length === 0;
	}
}

if (typeof String.notEmpty === "undefined") {
	String.notEmpty = function(str) {
		return str !== undefined && str !== null && str.length > 0;
	}
}

if (typeof String.prototype.hashCode === "undefined") {
	String.prototype.hashCode = function() {
		let hash = 0, i, chr;
		if (this.length === 0) return hash;
		for (i = 0; i < this.length; i++) {
			chr   = this.charCodeAt(i);
			hash  = ((hash << 5) - hash) + chr;
			hash |= 0; // Convert to 32bit integer
		}
		return hash;
	}
}

